import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, useEffect } from 'react';
import { NotificationLevel, ToastNotification } from '../../notifications/models/notification.model';
import { INotificationsService } from '../../notifications/services/notifications.service';
import { useAuthService } from '../auth.service';
import { IAuthStore } from '../auth.store';
import { AuthLogo } from '../components/AuthLogo';

export const AuthContainer = observer((props: PropsWithChildren): ReactElement => {
  const authService = useAuthService();
  const authStore = useInjection(IAuthStore.$);
  const notificationService = useInjection(INotificationsService.$);

  useEffect(() => {
    if (authStore.versionChanged) {
      void notificationService.push(new ToastNotification(NotificationLevel.INFO, 'aplication_updated'));
      authService.showVersionChangedMessage(false);
    }
  }, []);

  return (
    <div className='auth-outer-container'>
      <AuthLogo />
      {props.children}
    </div>
  );
});
